module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_photowedding_03-c1ef1cfe25e9daab10f29332181f76fd.webp";